import React, { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { toastMaker } from "../utils/utility";
import { RESET_PASSWORD } from "../API_LIST";
import matrimonyInstance from "../utils/axios";

const ResetPasswordPage = () => {
	const [newPassword, setNewPassword] = useState("");
	const [confirmPassword, setConfirmPassword] = useState("");
	const [showNewPassword, setShowNewPassword] = useState(false);
	const [showConfirmPassword, setShowConfirmPassword] = useState(false);
	const [passwordsMatch, setPasswordsMatch] = useState(true);
	const [searchParams] = useSearchParams();
	const token = searchParams.get("token");
	const email = searchParams.get("id");

	const navigate = useNavigate();

	useEffect(() => {
		localStorage.clear();
	}, []);

	useEffect(() => {
		setPasswordsMatch(
			newPassword === confirmPassword || confirmPassword === "",
		);
	}, [newPassword, confirmPassword]);

	const resetPassword = async (e) => {
		e.preventDefault();

		if (!newPassword || !confirmPassword) {
			toastMaker("Please fill out both password fields", "error");
			return;
		}
		if (!passwordsMatch) {
			toastMaker("Passwords do not match!", "error");
			return;
		}

		try {
			const response = await matrimonyInstance.post(RESET_PASSWORD, {
				email: email,
				token: token,
				password: newPassword,
			});

			if (response.status === 200) {
				toastMaker("Password updated", "success");
				setTimeout(navigate("/login"), 2000);
			} else {
				toastMaker("Failed to reset password. Try again.", "error");
			}
		} catch (error) {
			toastMaker("Error resetting password", "error");
		}
	};

	return (
		<div className="container">
			<div className="login-section padding-tb">
				<div className="row align-items-center">
					<div className="account-container">
						<div className="d-flex gap-5">
							<h3 className="account-title cursor-pointer">Reset Password</h3>
						</div>
						<div className="row justify-content-between">
							<div className="col-12 col-lg-7 col-sm-12">
								<div className="account-wrapper">
									<form onSubmit={resetPassword}>
										<div className="account-form">
											<div className="form-title">
												<p className="mb-10">
													Please enter your new password below
												</p>
											</div>
											<div className="row mt-20 justify-content-center">
												<div className="col-lg-12 col-sm-12 col-12 px-3">
													<div className="form-group">
														<div className="input-title">New Password</div>
														<div className="input-field position-relative">
															<input
																type={showNewPassword ? "text" : "password"}
																placeholder="Enter new password"
																className="with-icon input-icon"
																name="newPassword"
																value={newPassword}
																onChange={(e) => setNewPassword(e.target.value)}
															/>
															<div className="login-icon">
																<img
																	src="../assets/images/bat-img/login-password.svg"
																	alt="password icon"
																/>
															</div>
															<div
																className="password-visible-icon"
																onClick={() =>
																	setShowNewPassword(!showNewPassword)
																}
															>
																{showNewPassword ? (
																	<svg
																		xmlns="http://www.w3.org/2000/svg"
																		fill="none"
																		viewBox="0 0 24 24"
																		strokeWidth={1.5}
																		stroke="currentColor"
																		className="size-6"
																	>
																		<path
																			strokeLinecap="round"
																			strokeLinejoin="round"
																			d="M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178Z"
																		/>
																		<path
																			strokeLinecap="round"
																			strokeLinejoin="round"
																			d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
																		/>
																	</svg>
																) : (
																	<svg
																		xmlns="http://www.w3.org/2000/svg"
																		fill="none"
																		viewBox="0 0 24 24"
																		strokeWidth={1.5}
																		stroke="currentColor"
																		className="size-6"
																	>
																		<path
																			strokeLinecap="round"
																			strokeLinejoin="round"
																			d="M3.98 8.223A10.477 10.477 0 0 0 1.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.451 10.451 0 0 1 12 4.5c4.756 0 8.773 3.162 10.065 7.498a10.522 10.522 0 0 1-4.293 5.774M6.228 6.228 3 3m3.228 3.228 3.65 3.65m7.894 7.894L21 21m-3.228-3.228-3.65-3.65m0 0a3 3 0 1 0-4.243-4.243m4.242 4.242L9.88 9.88"
																		/>
																	</svg>
																)}
															</div>
														</div>
													</div>
												</div>

												<div className="col-lg-12 col-sm-12 col-12 px-3">
													<div className="form-group">
														<div className="input-title">Confirm Password</div>
														<div className="input-field position-relative">
															<input
																type={showConfirmPassword ? "text" : "password"}
																placeholder="Confirm your password"
																className="with-icon input-icon"
																name="confirmPassword"
																value={confirmPassword}
																onChange={(e) =>
																	setConfirmPassword(e.target.value)
																}
															/>
															<div className="login-icon">
																<img
																	src="../assets/images/bat-img/login-password.svg"
																	alt="password icon"
																/>
															</div>
															<div
																className="password-visible-icon"
																onClick={() =>
																	setShowNewPassword(!showNewPassword)
																}
															>
																{showNewPassword ? (
																	<svg
																		xmlns="http://www.w3.org/2000/svg"
																		fill="none"
																		viewBox="0 0 24 24"
																		strokeWidth={1.5}
																		stroke="currentColor"
																		className="size-6"
																	>
																		<path
																			strokeLinecap="round"
																			strokeLinejoin="round"
																			d="M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178Z"
																		/>
																		<path
																			strokeLinecap="round"
																			strokeLinejoin="round"
																			d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
																		/>
																	</svg>
																) : (
																	<svg
																		xmlns="http://www.w3.org/2000/svg"
																		fill="none"
																		viewBox="0 0 24 24"
																		strokeWidth={1.5}
																		stroke="currentColor"
																		className="size-6"
																	>
																		<path
																			strokeLinecap="round"
																			strokeLinejoin="round"
																			d="M3.98 8.223A10.477 10.477 0 0 0 1.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.451 10.451 0 0 1 12 4.5c4.756 0 8.773 3.162 10.065 7.498a10.522 10.522 0 0 1-4.293 5.774M6.228 6.228 3 3m3.228 3.228 3.65 3.65m7.894 7.894L21 21m-3.228-3.228-3.65-3.65m0 0a3 3 0 1 0-4.243-4.243m4.242 4.242L9.88 9.88"
																		/>
																	</svg>
																)}
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
										<div className="account-bottom1 text-center">
											<button
												className="button login-btn create-btn text-white"
												onClick={resetPassword}
												type="submit"
											>
												Reset Password
											</button>
										</div>
									</form>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default ResetPasswordPage;
